module.exports = __webpack_public_path__ + "static/rightink-d7c90f354ab58bc6f30aeb3174b8dfd8.jpg";